export type EcommerceOAuthResult = {
    isSuccess: boolean
    errorMessage?: string
}

export const OAUTH_RESULT_PARAM_NAMES = ["platform", "success", "error_type", "error_description"]

const OAUTH_ERROR_MESSAGES: Record<string, string> = {
    provider_denied: "The store declined the authorization request.",
    missing_code: "The store's authorization response was incomplete. Please try again.",
    code_exchange: "We couldn't finish connecting the store. Please try again.",
}

/**
 * Extracts an oauth flow outcome from the query params the callback redirect carries.
 *
 * Returns null when the page load isn't an oauth return (no `success` param). Provider-supplied
 * error descriptions win over our per-error-type copy, which itself falls back to a generic message.
 */
export function extractOAuthResult(searchParams: URLSearchParams): EcommerceOAuthResult | null {
    const success = searchParams.get("success")
    if (success === null) {
        return null
    }

    if (success === "true") {
        return { isSuccess: true }
    }

    const errorType = searchParams.get("error_type") ?? ""
    const errorDescription = searchParams.get("error_description")

    return {
        isSuccess: false,
        errorMessage:
            errorDescription ||
            OAUTH_ERROR_MESSAGES[errorType] ||
            "The store connection could not be completed. Please try again.",
    }
}
